import IconButton from '@material-ui/core/IconButton';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import RefreshIcon from '@material-ui/icons/Refresh';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip'
import { useActions, useValues } from 'kea';
import { Button, Typography } from '@material-ui/core';

import { maplogic, preferenceslogic, replaylogic, infowindowlogic } from 'src/store/global';
import vehiclelogic from 'src/store/vehicle';
import alertlogic from 'src/store/alert';

const ActionButtons = ({ row }) => {

	const { vehicles } = useValues(maplogic);
	const { addOne, removeOne } = useActions(maplogic);
	const { fetchUpdatedPosition, setHistory, setReplay, setNearbyAssets } = useActions(vehiclelogic);
	const { replay } = useValues(preferenceslogic);
	const { set: setInfoWindowVehicle } = useActions(infowindowlogic);
	const { fetchAll: AlertFetchAll } = useActions(alertlogic);

	const handle_focus = (existing_tracker) => {
		const pos = existing_tracker.status[0];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			global.gmap.setZoom(15);
		}
	}

	const includes_mobile_vehicles_on_map = (mobile_vehicle) => {
		let flag = vehicles.find((item) => {
			return item._id === mobile_vehicle._id;
		});
		if (flag === undefined) {
			return false;
		}
		return true;
	}

	const handle_visible = (row) => {
		if (includes_mobile_vehicles_on_map(row)) {
			removeOne(row);
		} else {
			addOne(row);
			handle_focus(row.tracker);
			setInfoWindowVehicle(row);
			setHistory([])
			setReplay([])
			setNearbyAssets([])
		}
	}

	const handleFetchNewPosition = () => {
		fetchUpdatedPosition([row], new Date())
		AlertFetchAll();
	}


	return (
		<div id={'rnd-ignore-drag'}>
			{
				replay.show ?
					<>
						<IconButton
							disabled
							variant="text"
							size='small'
						>
							<Typography> Disabled due to replay</Typography>
						</IconButton>
					</>
					:
					<>
						<Tooltip title={includes_mobile_vehicles_on_map(row) ? "Hide" : "Show"}>
							<IconButton
								disabled={!row?.tracker?.status?.length}
								size='small'
								onClick={() => handle_visible(row)}
							>
								{includes_mobile_vehicles_on_map(row) ? <VisibilityOffIcon /> : <VisibilityIcon />}
								<Typography>{includes_mobile_vehicles_on_map(row) ? "Hide" : "Show"}</Typography>
							</IconButton>
						</Tooltip>
						<Tooltip title='Zoom on map'>
							<IconButton
								disabled={!row?.tracker?.status?.length || !includes_mobile_vehicles_on_map(row)}
								size='small'
								onClick={() => handle_focus(row.tracker)}
							>
								<CenterFocusStrongIcon
								/>
								<Typography>Zoom</Typography>
							</IconButton>
						</Tooltip>
						<Tooltip title='Manully fetch latest position'>
							<IconButton
								size='small'
								onClick={handleFetchNewPosition}
							>
								<RefreshIcon
								/>
							</IconButton>
						</Tooltip>
					</>
			}
		</div>

	);
};

ActionButtons.propTypes = {
	row: PropTypes.object.isRequired
};

export default ActionButtons;
